var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-affiliate-payment-information"},[_c('h2',[_vm._v("支払情報管理")]),[_c('el-row',[_c('el-col',[_c('PaymentList',{attrs:{"dateRange":_vm.dateRange}})],1)],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }